import React from "react"

const Name = cell => {
  return cell.value ? cell.value : "-"
}

const Email = cell => {
  return cell.value ? cell.value : "-"
}

const UserGroups = cell => {
  if (!cell.value) return "-"

  if (Array.isArray(cell.value)) {
    // Handle new object structure: { groupId, groupCode, groupName, comments }
    if (cell.value.length > 0 && typeof cell.value[0] === 'object') {
      return cell.value.map(group => group.groupName || group.groupCode).join(", ")
    }
    // Handle legacy string array structure
    return cell.value.join(", ")
  }

  return cell.value
}

const State = cell => {
  const state = cell.value
  return (
    <span>
      {state ? state : "-"}
    </span>
  )
}

export { Name, Email, UserGroups, State }
